<template>
  <div class="location">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Bio</h4>
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Full name</h6>

        <a-input size="large" placeholder="John Doe" v-model="fullName" class="mx-auto mb-3" />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Phone number</h6>

        <a-input size="large" v-model="phone" placeholder class="mx-auto mb-3" />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Location</h6>
        <a-select
          class="w-100 mb-3"
          size="large"
          placeholder="Please select your Country"
          v-model="location"
        >
          <a-select-option v-for="item in countries" :key="item">{{item}}</a-select-option>
        </a-select>
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Timezone</h6>

        <a-input size="large" v-model="timezone" placeholder="e.g GMT +1" class="mx-auto mb-3" />
        <br />

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <router-link to="/onboarding-review">
                <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "bio",
  data() {
    return {
      countries: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States of America (the)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],
      fullName: this.$store.state.client.clientData.fullName,
      phone: this.$store.state.client.clientData.phone,
      location: this.$store.state.client.clientData.location,
      timezone: this.$store.state.client.clientData.timezone
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { fullName, phone, location, timezone } = this;
      this.$store.commit("client/updateClient", {
        fullName,
        phone,
        location,
        timezone
      });
      this.$router.push("onboarding-review");
    },
    skip() {
      this.$router.push("onboarding-review");
    }
  },
  mounted() {}
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
